import { AlertMessageService } from '../core/alert-message.service';
import { Error } from '../shared/models/general-responses.model';
import { Task } from '../shared/models/task.model';

export function sortActivityRowsOnComparison(columnName: string) {
  switch (columnName) {
    case 'taskName':
      return (a: Task, b: Task) => a.taskName.localeCompare(b.taskName);
    case 'assignedToName':
      return (a: Task, b: Task) =>
        a.assignedToName.localeCompare(b.assignedToName);
    case 'status':
      return (a: Task, b: Task) => a.status - b.status;
    case 'endDate':
      return (a: Task, b: Task) =>
        a.endDate.valueOf() - b.endDate.valueOf();
    default:
      return (a: Task, b: Task) => a.taskName.localeCompare(b.taskName);
  }
}

export function handleApiResponse<T>(
  response: { status: 'SUCCESS' | 'ERROR'; error: Error; response?: T },
  alertService: AlertMessageService
): T {
  if (response.error['has-error']) {
    const error = response.error.error!;
    alertService.updateAlert(error);
    alertService.changeErrorState(true);
    return {} as T;
  }
  return response.response!;
}

export function generateUUID(): string {
  return crypto.randomUUID();
}
